const languages = [
    {title: "Français", key: "fr", icon: "/images/french.png"},
    {title: "English", key: "en", icon: "/images/english.png"},
]
export default languages